import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Thumbnail extends Vue {
    private imageOrientation = ''
    @Prop()
    private imageUrl!: string

    private rotateImage(orientation: string) {
        return (orientation == '3') ? 'rotation180' : (orientation == '6') ? 'rotation90' : (orientation == '8') ? 'rotation-minus90' : '';
    }
}